import React from "react";
import '../App.css';
import '../nav/Nav-Header'
import Header from "../nav/Nav-Header";
import 'bulma/css/bulma.min.css';
import {Container, Columns, Notification, Button} from 'react-bulma-components';
import SensorDataBox from "../cards/SensorData";



function Sensor() {

    return (

        <div className="App">
            <Header />

            <Container style={{
                top: '8vh'
            }}>
                <Columns>
                    <Columns.Column>
                        <SensorDataBox />
                    </Columns.Column>
                </Columns>

            </Container>
        </div>
    );
}

export default Sensor;
